// eslint-disable-next-line import/no-amd
define([
    '../../../utils/Globals',
    'jquery',
    'underscore',
    'backbone',
    '../templates/row_view.template'
], (Globals, $, _, Backbone, html) => {
    const RowView = Backbone.View.extend({
        initialize() {
        },
        render() {
            const view = this;
            const tstring = _.template(html)({ model: view.model, i18n: Globals.i18n });
            view.$el.html(tstring);
        },
        events: {
            'click .benutzerliste li': 'showDetail'
        },
        showDetail(event) {
            const id = $(event.target).closest('li').data('id');
            console.log(id);
            this.detailView.render(id);
        }
    });
    return RowView;
});



// WEBPACK FOOTER //
// ./src/components/protocol/views/RowView.js